/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-subject[_ngcontent-%COMP%]{position:relative}.ea-subject-popover[_ngcontent-%COMP%]{top:100%;left:50%;transform:translateX(-50%)}"];
export { styles as styles };
